<template>
	<div>
		<mainHeader></mainHeader>
		<keep-alive>
		<router-view />
		</keep-alive>
		<mainFooter></mainFooter>
	</div>
</template>

<script>
	import mainHeader from "@/components/header.vue"
	import mainFooter from '@/components/footer.vue'
	export default{
		components:{
			mainHeader,
			mainFooter
		}
	}
</script>

<style>
</style>